module.exports = __webpack_public_path__ + "static/media/food_anchorage_3.6a1a850b.svg";